// components/Reusablesteps/Stepperprogress.jsx
import React from "react";
import styles from "./Stepperprogress.module.css";

/**
 * StepperProgress
 * @param {number} current  - 0-based current step index
 * @param {number} total    - Total steps
 *
 * Segment states:
 *  i < current  → completed → green
 *  i === current → active   → primary purple
 *  i > current  → future    → grey
 */
const StepperProgress = ({ current = 0, total = 5 }) => {
  const label = `${String(current + 1).padStart(2, "0")} / ${String(total).padStart(2, "0")}`;

  return (
    <div className={styles.wrapper}>
      <span className={styles.counter}>{label}step</span>
      <div className={styles.segRow}>
        {Array.from({ length: total }).map((_, i) => {
          const segClass =
            i < current
              ? `${styles.seg} ${styles.segActive}`   // completed → green
              : i === current
              ? `${styles.seg} ${styles.segCurrent}`  // current   → purple
              : styles.seg;                            // future    → grey

          return <div key={i} className={segClass} />;
        })}
      </div>
    </div>
  );
};

export default StepperProgress;